import React from "react";
import cx from "classnames";
import dayjs from "dayjs";
import stylesV2 from "./DoctorCard.module.scss";
import stylesV3 from "./DoctorCardV2.module.scss";
// eslint-disable-next-line no-restricted-imports
import { DiscountCard } from "./DiscountCard";
import { Doctor } from "types/doctor";
import { Slot } from "types/slot";
import { DoctorAvatar } from "components/DoctorAvatar";
import { RetiringLabel } from "features/scheduling/components/RetiringLabel";
import { doctorFullName, doctorDiscountNameVEH } from "utils/doctorFullName";
import { parseStartTime } from "features/appointmentTime";
import { Office } from "types/office";
import { useSchedulingABVariant } from "../utils/useSchedulingABVariant";

interface DoctorCardProps {
  doctor: Doctor;
  selectedOffice: Office;
  slot: Slot;
  isEditForm: false;
  searchDate: string;
  onClick: () => void;
}

export const DoctorCard: React.FC<DoctorCardProps> = ({
  doctor,
  selectedOffice,
  slot,
  isEditForm,
  searchDate,
  onClick,
}) => {
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;
  const formattedTime = parseStartTime(slot).format("h:mm A");
  const vehThreeheadshot =
    doctor.offersVEH && doctor.headshotUrl
      ? doctor.headshotUrl.includes("OD_Group_Final_3.png")
      : false;
  //const showDiscount = dayjs().add(13, "day") > dayjs(searchDate);
  const discountVEHDoctor = doctorDiscountNameVEH();
  const doctorName =
    doctor.offersVEH && selectedOffice.discountVEH && discountVEHDoctor
      ? doctorDiscountNameVEH()
      : doctorFullName(doctor);
  return (
    <>
      <div
        className={
          !isEditForm ? styles.container : cx(styles.container, styles.moveTop)
        }
      >
        <div className={styles.headerSection}>
          <div className={styles.heading}>Selected Doctor and Time</div>
          <div
            className={styles.action}
            onClick={() => onClick()}
            aria-hidden="true"
          >
            Change
          </div>
        </div>
        <div
          className={
            doctor.retiringDate
              ? cx(styles.contentSection, styles.retiringSection)
              : styles.contentSection
          }
        >
          <div
            className={
              vehThreeheadshot
                ? cx(styles.contentLeft, styles.vehcontentLeft)
                : styles.contentLeft
            }
          >
            <DoctorAvatar
              doctor={doctor}
              size="small"
              selectedOffice={selectedOffice}
            />
          </div>
          <div
            className={
              vehThreeheadshot
                ? cx(styles.contentRight, styles.vehcontentRight)
                : styles.contentRight
            }
          >
            <div className={styles.doctorName}>{doctorName}</div>
            {doctor.offersVEH &&
              selectedOffice.discountVEH &&
              doctor.firstName.toLowerCase().includes("open network") && (
                <DiscountCard />
              )}
            {doctor.retiringDate && (
              <RetiringLabel doctor={doctor} calledFrom="selectedDoctor" />
            )}
            <div className={styles.timeSlot}>
              {dayjs(slot.date).format("ddd, MMM D, YYYY")} at {formattedTime}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
